var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _path, _path2, _path3, _path4, _path5, _path6, _g11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14588,
    height: 9367,
    viewBox: "0 0 14588 9367",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13_213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14271.1 8923.17L14246.5 8146.41V6961.94H14496.1V9323.85H14207.9L13722.8 8100.72C13704.1 8051.51 13611.5 7806.65 13445.2 7366.13L13466.3 8139.38V9323.85H13223.7V6961.94H13512C13884.5 7908.58 14137.6 8562.32 14271.1 8923.17Z",
    fill: "#2F2F2F"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_13_213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12524.2 7489.15C12524.2 7266.55 12408.2 7155.25 12176.3 7155.25C11946.6 7155.25 11831.8 7266.55 11831.8 7489.15V8796.64C11831.8 9021.58 11946.6 9134.06 12176.3 9134.06C12408.2 9134.06 12524.2 9021.58 12524.2 8796.64V7489.15ZM11582.3 7485.63C11582.3 7319.27 11632.6 7184.54 11733.4 7081.44C11834.2 6978.34 11981.8 6926.79 12176.3 6926.79C12373.1 6926.79 12521.9 6978.34 12622.6 7081.44C12723.4 7184.54 12773.8 7319.27 12773.8 7485.63V8803.67C12773.8 8970.03 12723.4 9104.77 12622.6 9207.87C12521.9 9308.62 12373.1 9359 12176.3 9359C11979.4 9359 11830.6 9308.62 11729.9 9207.87C11631.5 9104.77 11582.3 8970.03 11582.3 8803.67V7485.63Z",
    fill: "#2F2F2F"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_13_213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10882.9 6961.94H11132.4V9323.85H10882.9V6961.94Z",
    fill: "#2F2F2F"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_13_213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10610.1 6961.94V7183.37H10153.2V9323.85H9900.1V7183.37H9443.18V6961.94H10610.1Z",
    fill: "#2F2F2F"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_13_213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8235.69 7443.46C8235.69 7110.73 8446.57 6944.36 8868.34 6944.36C9004.25 6944.36 9140.15 6963.11 9276.06 7000.6V7232.57C9137.81 7192.74 8999.56 7172.82 8861.31 7172.82C8723.07 7172.82 8625.83 7197.42 8569.59 7246.63C8513.35 7293.49 8485.24 7363.79 8485.24 7457.52V8831.79C8485.24 8923.17 8513.35 8993.46 8569.59 9042.67C8628.17 9089.53 8728.93 9112.97 8871.86 9112.97C9017.14 9112.97 9154.21 9094.22 9283.08 9056.73V9285.19C9165.93 9322.68 9027.68 9341.43 8868.34 9341.43C8446.57 9341.43 8235.69 9175.06 8235.69 8842.33V7443.46Z",
    fill: "#2F2F2F"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_13_213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7554.47 6961.94H7804.02V8803.67C7804.02 8970.03 7753.64 9104.77 7652.88 9207.87C7554.47 9308.62 7406.85 9359 7210.02 9359C7013.2 9359 6864.4 9308.62 6763.65 9207.87C6665.23 9104.77 6616.03 8970.03 6616.03 8803.67V6961.94H6865.58V8796.64C6865.58 9021.58 6980.39 9134.06 7210.02 9134.06C7439.65 9134.06 7554.47 9021.58 7554.47 8796.64V6961.94Z",
    fill: "#2F2F2F"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_13_213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5938.19 7496.18C5938.19 7285.29 5826.89 7179.85 5604.29 7179.85H5249.3V9102.42H5604.29C5826.89 9102.42 5938.19 8994.64 5938.19 8779.06V7496.18ZM4999.75 6961.94H5618.35C5805.8 6961.94 5947.56 7009.97 6043.63 7106.04C6139.7 7202.11 6187.74 7330.99 6187.74 7492.66V8786.09C6187.74 8952.46 6140.87 9083.68 6047.15 9179.75C5953.42 9275.82 5812.83 9323.85 5625.37 9323.85H4999.75V6961.94Z",
    fill: "#2F2F2F"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_13_213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4300.22 7489.15C4300.22 7266.55 4184.23 7155.25 3952.26 7155.25C3722.62 7155.25 3607.81 7266.55 3607.81 7489.15V8796.64C3607.81 9021.58 3722.62 9134.06 3952.26 9134.06C4184.23 9134.06 4300.22 9021.58 4300.22 8796.64V7489.15ZM3358.26 7485.63C3358.26 7319.27 3408.64 7184.54 3509.4 7081.44C3610.15 6978.34 3757.77 6926.79 3952.26 6926.79C4149.08 6926.79 4297.87 6978.34 4398.63 7081.44C4499.39 7184.54 4549.76 7319.27 4549.76 7485.63V8803.67C4549.76 8970.03 4499.39 9104.77 4398.63 9207.87C4297.87 9308.62 4149.08 9359 3952.26 9359C3755.43 9359 3606.64 9308.62 3505.88 9207.87C3407.47 9104.77 3358.26 8970.03 3358.26 8803.67V7485.63Z",
    fill: "#2F2F2F"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_13_213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2384.56 8374.87H2036.59V9323.85H1787.05V6961.94H2359.95C2547.41 6961.94 2689.17 7009.97 2785.24 7106.04C2881.31 7199.77 2929.34 7328.64 2929.34 7492.66V7840.62C2929.34 8093.69 2828.59 8257.71 2627.07 8332.69L3003.15 9323.85H2729L2384.56 8374.87ZM2036.59 8156.95H2349.41C2569.67 8156.95 2679.79 8050.34 2679.79 7837.11V7503.21C2679.79 7289.98 2569.67 7183.37 2349.41 7183.37H2036.59V8156.95Z",
    fill: "#2F2F2F"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d_13_213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1135.24 7506.72C1135.24 7291.15 1023.94 7183.37 801.342 7183.37H492.044V8290.51H801.342C1023.94 8290.51 1135.24 8183.9 1135.24 7970.67V7506.72ZM242.496 6961.94H815.401C1000.51 6961.94 1141.1 7009.97 1237.17 7106.04C1335.59 7202.11 1384.79 7330.99 1384.79 7492.66V7981.21C1384.79 8145.24 1336.76 8275.28 1240.69 8371.35C1144.62 8465.08 1002.86 8511.94 815.401 8511.94H492.044V9323.85H242.496V6961.94Z",
    fill: "#2F2F2F"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12626.1 6022.28C12423.4 6022.28 12244.4 5980.53 12089.3 5897.03C11936.7 5813.53 11817.4 5699.01 11731.5 5553.48C11648 5407.95 11606.2 5240.94 11606.2 5052.47C11606.2 4863.99 11646.8 4696.99 11727.9 4551.45C11811.4 4405.92 11924.7 4292.6 12067.9 4211.48C12213.4 4127.98 12376.8 4086.23 12558.2 4086.23C12741.9 4086.23 12904.1 4126.79 13044.9 4207.9C13185.6 4289.02 13295.4 4403.53 13374.1 4551.45C13455.2 4696.99 13495.8 4867.57 13495.8 5063.2C13495.8 5077.52 13494.6 5094.22 13492.2 5113.3C13492.2 5132.39 13491 5150.28 13488.6 5166.98H11874.6V4920.06H13309.7L13170.1 5005.94C13172.5 4884.27 13147.4 4775.72 13095 4680.28C13042.5 4584.85 12969.7 4510.89 12876.7 4458.41C12786 4403.53 12679.8 4376.1 12558.2 4376.1C12438.9 4376.1 12332.7 4403.53 12239.7 4458.41C12146.6 4510.89 12073.8 4586.05 12021.4 4683.86C11968.9 4779.29 11942.6 4889.04 11942.6 5013.1V5070.36C11942.6 5196.8 11971.3 5310.13 12028.5 5410.33C12088.2 5508.15 12170.5 5584.49 12275.4 5639.37C12380.4 5694.24 12500.9 5721.68 12636.9 5721.68C12749 5721.68 12850.4 5702.59 12941.1 5664.42C13034.1 5626.24 13115.2 5568.99 13184.4 5492.64L13374.1 5714.52C13288.2 5814.72 13180.8 5891.07 13052 5943.55C12925.6 5996.04 12783.6 6022.28 12626.1 6022.28Z",
    fill: "#2F2F2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9935.86 5542.74L9943.02 5102.57L11034.5 4104.12H11449.6L10612.2 4927.21L10426.1 5084.67L9935.86 5542.74ZM9656.73 6000.81V3345.44H10000.3V6000.81H9656.73ZM11106.1 6000.81L10361.7 5077.52L10583.6 4801.96L11528.4 6000.81H11106.1Z",
    fill: "#2F2F2F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8233.63 4086.23C8388.71 4086.23 8524.7 4116.05 8641.6 4175.69C8760.89 4235.34 8853.93 4326 8920.73 4447.67C8987.54 4569.35 9020.94 4723.23 9020.94 4909.32V6000.81H8677.39V4948.68C8677.39 4764.98 8632.06 4626.6 8541.4 4533.56C8453.12 4440.51 8327.87 4393.99 8165.64 4393.99C8043.96 4393.99 7937.8 4417.85 7847.14 4465.56C7756.48 4513.28 7686.1 4583.66 7636 4676.71C7588.28 4769.75 7564.42 4885.46 7564.42 5023.84V6000.81H7220.87V4104.12H7550.11V4615.87L7496.43 4479.88C7558.46 4355.82 7653.89 4259.2 7782.72 4190.01C7911.55 4120.82 8061.86 4086.23 8233.63 4086.23Z",
    fill: "#2F2F2F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5597.02 6022.28C5434.79 6022.28 5291.64 5992.46 5167.58 5932.82C5045.91 5873.17 4950.48 5782.51 4881.29 5660.84C4814.49 5536.78 4781.09 5381.7 4781.09 5195.61V4104.12H5124.64V5156.25C5124.64 5342.34 5168.77 5481.9 5257.05 5574.95C5347.71 5667.99 5474.15 5714.52 5636.39 5714.52C5755.67 5714.52 5859.46 5690.66 5947.73 5642.94C6036 5592.84 6104 5521.27 6151.71 5428.22C6199.43 5332.79 6223.29 5218.28 6223.29 5084.67V4104.12H6566.84V6000.81H6241.18V5489.06L6294.86 5625.05C6232.83 5751.5 6139.78 5849.31 6015.72 5918.5C5891.66 5987.69 5752.1 6022.28 5597.02 6022.28Z",
    fill: "#2F2F2F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14587.5 6007.99V3831.05H14210.2V4422.52L14247.1 4274.65C14186.9 4124.05 14085.8 4009.04 13943.6 3929.63C13801.4 3850.22 13626.4 3810.51 13418.6 3810.51V4192.5C13435 4189.77 13451.4 4188.4 13467.8 4188.4C13481.5 4188.4 13495.2 4188.4 13508.8 4188.4C13719.4 4188.4 13886.2 4251.38 14009.2 4377.34C14132.2 4503.3 14193.8 4685.39 14193.8 4923.63V6007.99H14587.5Z",
    fill: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13_213",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 5050,
    height: 6570
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H5049.51V6569.04H0V0Z",
    fill: "#D9D9D9"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13_213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M958.473 958.472H3062.44V2805.29H958.473V958.472Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.473 3693.63H3249.46V5563.82H958.473V3693.63Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_d_13_213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 6569.04V-70.1321H2278.97C2865.37 -70.1321 3305.17 87.9434 3598.37 404.095C3896.01 720.246 4044.83 1137.57 4044.83 1656.05C4044.83 2003.82 3984.86 2307.32 3864.91 2566.57C3744.97 2819.49 3580.6 3015.5 3371.8 3154.61C3163.01 3293.72 2923.12 3363.27 2652.13 3363.27L2778.74 2974.4C3071.94 2974.4 3331.82 3043.96 3558.39 3183.06C3784.95 3315.85 3960.43 3515.02 4084.81 3780.59C4213.65 4046.16 4278.06 4371.79 4278.06 4757.5C4278.06 5326.57 4120.35 5772.34 3804.94 6094.82C3489.53 6410.97 3025.29 6569.04 2412.24 6569.04H0ZM1072.85 5411.93H2332.28C2612.15 5411.93 2823.16 5348.7 2965.32 5222.24C3111.92 5089.46 3185.22 4880.8 3185.22 4596.26C3185.22 4318.05 3111.92 4112.55 2965.32 3979.76C2823.16 3840.66 2612.15 3771.11 2332.28 3771.11H992.883V2651.93H2145.69C2407.8 2651.93 2607.71 2588.7 2745.42 2462.24C2887.58 2329.46 2958.66 2130.28 2958.66 1864.71C2958.66 1605.47 2887.58 1412.62 2745.42 1286.16C2607.71 1153.37 2407.8 1086.98 2145.69 1086.98H1072.85V5411.93Z",
    fill: "#EC7131"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13_213",
    x: 13222.7,
    y: 6961.94,
    width: 1280.34,
    height: 2369.92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13_213"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13_213",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_13_213",
    x: 11581.3,
    y: 6926.79,
    width: 1199.5,
    height: 2440.21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13_213"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13_213",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_13_213",
    x: 10881.9,
    y: 6961.94,
    width: 257.547,
    height: 2369.92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13_213"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13_213",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_13_213",
    x: 9442.18,
    y: 6961.94,
    width: 1174.9,
    height: 2369.92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13_213"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13_213",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_13_213",
    x: 8234.69,
    y: 6944.36,
    width: 1055.4,
    height: 2405.06,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13_213"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13_213",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_13_213",
    x: 6615.03,
    y: 6961.94,
    width: 1195.99,
    height: 2405.06,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13_213"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13_213",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_13_213",
    x: 4998.75,
    y: 6961.94,
    width: 1195.99,
    height: 2369.92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13_213"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13_213",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_13_213",
    x: 3357.26,
    y: 6926.79,
    width: 1199.5,
    height: 2440.21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13_213"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13_213",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_13_213",
    x: 1786.05,
    y: 6961.94,
    width: 1224.11,
    height: 2369.92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13_213"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13_213",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_13_213",
    x: 241.496,
    y: 6961.94,
    width: 1150.3,
    height: 2369.92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13_213"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13_213",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_13_213",
    x: 0,
    y: -170.132,
    width: 4711.06,
    height: 6839.18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13_213"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13_213",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ce0496a8ca2babbcc1678df55b171287.svg";
export { ForwardRef as ReactComponent };